import journies from "../../Data/journey.json";

const JourneyBox = ({
  selectedJourney,
  setSelectedNode,
  setSelectedJourney,
}) => {
  const handleReset = () => {
    setSelectedNode(null);
    setSelectedJourney(null);
  };
  return (
    <>
      <h3>Select Journey: </h3>
      <div>
        {journies.map((item, index) => (
          <button
            key={index}
            className="toggle-button"
            style={
              selectedJourney?.id === item.id
                ? {
                    backgroundColor: "#B6DCE1",
                    boxShadow: "0px 0px 0px 2px #00263E",
                  }
                : undefined
            }
            onClick={() => {
              setSelectedNode(null);
              setSelectedJourney(item);
            }}
          >
            {item.title}
          </button>
        ))}
        <button className="toggle-button reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>
    </>
  );
};

export default JourneyBox;
